<template>
  <no-data-wrapper :has-data="hasData">
    <bar-chart :data="chartData" :options="options" style="height: 100%" />
  </no-data-wrapper>
</template>

<i18n lang="yaml">
ja:
  indoor: '内部発生'
  outdoor: '外部侵入'
en:
  indoor: 'indoor'
  outdoor: 'outdoor'
</i18n>

<script>
import BarChart from '@/components/atoms/BarChart';
import NoDataWrapper from './NoDataWrapper';

import { indoorColor, outdoorColor } from './colors';
import ChartHelpers from './mixins/chartHelpers';

const WEEKDAY_LABELS = {
  ja: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
  en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
};

// Monday, Tuesday, ..., Sunday
const WEEKDAY_ORDER = [1, 2, 3, 4, 5, 6, 0];

export default {
  name: 'weekday-bar-chart',
  props: {
    events: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  components: {
    BarChart,
    NoDataWrapper,
  },
  mixins: [ChartHelpers],
  computed: {
    hasData() {
      return this.events && this.events.length > 0;
    },
    chartData() {
      return {
        labels: this.weekdayLabels,
        datasets: this.hasData ? this.normalDatasets : this.emptyDatasets,
      };
    },
    normalDatasets() {
      return [
        {
          backgroundColor: indoorColor,
          data: this.chartValues.indoor,
          label: this.$t('indoor'),
        },
        {
          backgroundColor: outdoorColor,
          data: this.chartValues.outdoor,
          label: this.$t('outdoor'),
        },
      ];
    },
    emptyDatasets() {
      return [
        {
          backgroundColor: 'transparent',
          data: new Array(7).fill(0),
          label: this.$t('indoor'),
        },
        {
          backgroundColor: 'transparent',
          data: new Array(7).fill(0),
          label: this.$t('outdoor'),
        },
      ];
    },
    options() {
      return {
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          x: {
            stacked: true,
          },
          y: {
            stacked: true,
            ticks: {
              precision: 0,
            },
          },
        },
      };
    },
    chartValues() {
      return {
        outdoor: WEEKDAY_ORDER.map(weekday => this.weeklyRouteCounts[weekday].outdoor),
        indoor: WEEKDAY_ORDER.map(weekday => this.weeklyRouteCounts[weekday].indoor),
      };
    },
    weekdayLabels() {
      const labels = WEEKDAY_LABELS[this.$i18n.locale];
      return WEEKDAY_ORDER.map(weekday => labels[weekday]);
    },
    weeklyRouteCounts() {
      const result = this.weekdayLabels.map(() => ({ indoor: 0, outdoor: 0 }));
      this.events.forEach(({ timestamp, chartInfo: { insectCountIncreases } }) => {
        const weekday = new Date(timestamp * 1000).getDay();
        const routeCounts = this.calcRouteCounts(insectCountIncreases);
        Object.keys(routeCounts).forEach((route) => {
          result[weekday][route] += routeCounts[route];
        });
      });
      return result;
    },
  },
};
</script>
